<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="商城促销配置" @back="goBack" /></span>
        </div>

        <el-table style="border:1px solid #ccc" :data="formData" border stripe>
          <el-table-column prop="start" label="等级范围" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.start" style="width: 35%" />
              -
              <el-input v-model="scope.row.end" style="width: 35%" />
            </template>
          </el-table-column>
          <el-table-column prop="buyNum" label="限制次数" align="center">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.buyNum" />
            </template>
          </el-table-column>

          <el-table-column prop="bet" label="倍数" align="center">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.bet" />
            </template>
          </el-table-column>

          <el-table-column prop="gids" label="商品" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" icon="el-icon-edit" @click="handleGid(scope.row.gids,scope.$index)">{{ showGid(scope.row.gids) }}</el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:shopPromotion:del']" size="mini" type="danger" @click="del(scope.$index)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="margin-top: 20px;text-align: center">
          <el-button v-permisaction="['config:shopPromotion:add']" type="primary" @click="add">+</el-button>
          <el-button v-permisaction="['config:shopPromotion:add']" :disabled="isOnline === 1" type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-card>

      <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
        size="550px"
        @close="closeHandleGid"
      >
        <el-form>
          <el-table :data="gidForm" border stripe>
            <el-table-column prop="gids" label="商品" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.gid" style="width: 100%" placeholder="请选择">
                  <el-option
                    v-for="item in gidsArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column prop="buyNum" label="限制次数" align="center">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.buyNum" />
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="delGid(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button style="margin-top: 10px" type="primary" @click="addGid">+</el-button>
        </el-form>
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyList, updateActivtyRewardConfData
} from '@/api/config/activity-cfg'
import { getShopGoodsList } from '@/api/config/shop-cfg'

export default {
  name: 'RewardShopPromotionEdit',
  data() {
    return {
      includeGidArr: [],
      gidForm: [],
      drawer: false,
      drawerIndex: -1,
      gidsArr: [],
      isOnline: 0,
      formData: [{
        'start': 0,
        'end': 0,
        'buyNum': 0,
        'bet': 0,
        gids: []
      }]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getGoodsList()
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (parseInt(val.start) > parseInt(val.end)) {
          this.msgError('最小等级不能大于最大等级')
          return
        }

        this.formData[i].start = parseInt(val.start)
        this.formData[i].end = parseInt(val.end)
        this.formData[i].buyNum = parseInt(val.buyNum)
        this.formData[i].bet = parseInt(val.bet)
      }

      const _data = JSON.stringify(this.formData)
      console.log(_data)
      updateActivtyRewardConfData({ data: _data, name: this.aid }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0].reward_conf
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getGoodsList() {
      getShopGoodsList({ pageIndex: 1, pageSize: 100, typeArr: [1, 2] }).then(res => {
        if (res.data.count > 0) {
          (res.data.list.forEach(item => {
            this.gidsArr.push({ label: item.gname, value: item.gid })
          }))
        }
      })
    },
    add() {
      this.formData.push({
        'start': 0,
        'end': 0,
        'buyNum': 0,
        'bet': 0,
        gids: []
      })
    },
    del(i) {
      this.formData = this.formData.filter((item, index) => {
        return index !== i
      })
    },
    handleGid(gidForm, idx) {
      this.drawerIndex = idx
      this.drawer = true
      if (!gidForm) {
        gidForm = []
      }
      this.refreshIncludeArr()
      this.gidForm = gidForm
    },
    addGid() {
      let gid = 0
      for (const i in this.gidsArr) {
        const val = this.gidsArr[i]
        if (!this.includeGidArr.includes(val.value)) {
          gid = val.value
          break
        }
      }

      if (gid < 1) {
        this.msgError('无可用商品')
        return
      }

      this.gidForm.push({ gid: gid, buyNum: 1 })
      this.refreshIncludeArr()
    },
    refreshIncludeArr() {
      this.includeGidArr = []
      for (const i in this.gidForm) {
        this.includeGidArr.push(this.gidForm[i].gid)
      }
    },
    delGid(idx) {
      this.gidForm = this.gidForm.filter((item, index) => {
        return index !== idx
      })
      this.refreshIncludeArr()
    },
    closeHandleGid() {
      this.formData[this.drawerIndex].gids = this.gidForm
    },
    showGid(data) {
      const arr = []
      data.forEach(item => {
        const title = this.getGidTitle(item.gid)
        arr.push(`${title}:${item.buyNum}`)
      })
      return arr.join(';')
    }, getGidTitle(gid) {
      let title = ''
      for (const i in this.gidsArr) {
        const val = this.gidsArr[i]
        if (val.value === gid) {
          title = val.label
          break
        }
      }
      return title
    }
  }
}
</script>

<style scoped>
</style>
